module.exports = "<div class=note v-bind:class=[size]> <h1>{{note.title}}</h1> <pre>{{note.content}}</pre> <button type=button v-on:click.stop=remove> <i class=\"fa fa-trash-o\" aria-hidden=true></i> </button> <button class=edit type=button> <i class=\"fa fa-pencil\" aria-hidden=true></i> </button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notes/Note.vue
 ** module id = 83
 ** module chunks = 0
 **/